function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginSinistri(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 416.779,
    y: 398.494,
    style: {
      fill: "#EBEBEB"
    },
    width: 33.122,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.527,
    y: 401.208,
    style: {
      fill: "#EBEBEB"
    },
    width: 8.693,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.586,
    y: 389.208,
    style: {
      fill: "#EBEBEB"
    },
    width: 19.192,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.459,
    y: 390.888,
    style: {
      fill: "#EBEBEB"
    },
    width: 43.193,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.556,
    y: 390.888,
    style: {
      fill: "#EBEBEB"
    },
    width: 6.333,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.471,
    y: 395.111,
    style: {
      fill: "#EBEBEB"
    },
    width: 93.676,
    height: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M237.014,337.8H43.915c-3.147,0-5.708-2.561-5.708-5.708V60.66c0-3.147,2.561-5.708,5.708-5.708 h193.099c3.146,0,5.707,2.561,5.707,5.708v271.432C242.721,335.239,240.16,337.8,237.014,337.8z M43.915,55.203 c-3.01,0-5.458,2.448-5.458,5.458v271.432c0,3.01,2.448,5.458,5.458,5.458h193.099c3.009,0,5.457-2.448,5.457-5.458V60.66 c0-3.009-2.448-5.458-5.457-5.458H43.915z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M453.31,337.8H260.212c-3.147,0-5.707-2.561-5.707-5.708V60.66c0-3.147,2.561-5.708,5.707-5.708 H453.31c3.148,0,5.708,2.561,5.708,5.708v271.432C459.019,335.239,456.458,337.8,453.31,337.8z M260.212,55.203 c-3.009,0-5.457,2.448-5.457,5.458v271.432c0,3.01,2.448,5.458,5.457,5.458H453.31c3.01,0,5.458-2.448,5.458-5.458V60.66 c0-3.009-2.448-5.458-5.458-5.458H260.212z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 382.398,
    style: {
      fill: "#EBEBEB"
    },
    width: 500,
    height: 0.25
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 100.193,
    y: 309.48,
    style: {
      fill: "#F5F5F5"
    },
    width: 72.769,
    height: 72.769
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.962,
    y: 309.48,
    style: {
      fill: "#EBEBEB"
    },
    width: 44.699,
    height: 72.769
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0E0E0"
    },
    points: "190.843,309.48 190.843,337.022 191.998,335.971 194.041,337.248 195.828,335.971  198.126,337.248 200.551,335.971 202.083,337.248 203.864,336.311 203.864,309.48  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.7,
      fill: "#E0E0E0"
    },
    points: "190.843,309.48 190.843,337.022 191.998,335.971 194.041,337.248  195.828,335.971 198.126,337.248 200.551,335.971 202.083,337.248 203.864,336.311 203.864,309.48  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 55.852,
    y: 338.919,
    style: {
      fill: "#F5F5F5"
    },
    width: 43.331,
    height: 43.331
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.182,
    y: 338.919,
    style: {
      fill: "#E6E6E6"
    },
    width: 26.616,
    height: 43.331
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E6E6E6"
    },
    points: "90.904,328.043 47.573,328.043 55.852,338.919 99.182,338.919  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EBEBEB"
    },
    points: "107.024,328.043 133.64,328.043 125.798,338.919 99.182,338.919  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M125.964,252.761h36.247c0.729,0,1.319,0.59,1.319,1.319v7.797c0,0.728-0.59,1.319-1.319,1.319 h-36.247c-0.728,0-1.319-0.591-1.319-1.319v-7.797C124.645,253.352,125.235,252.761,125.964,252.761z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M85.18,252.761h36.247c0.728,0,1.319,0.59,1.319,1.319v7.797c0,0.728-0.591,1.319-1.319,1.319 H85.18c-0.729,0-1.319-0.591-1.319-1.319v-7.797C83.861,253.352,84.451,252.761,85.18,252.761z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M103.344,239.83h36.247c0.729,0,1.319,0.59,1.319,1.319v7.797c0,0.728-0.59,1.319-1.319,1.319 h-36.247c-0.729,0-1.319-0.59-1.319-1.319v-7.797C102.025,240.42,102.616,239.83,103.344,239.83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M62.644,239.83h36.247c0.729,0,1.319,0.59,1.319,1.319v7.797c0,0.728-0.59,1.319-1.319,1.319 H62.644c-0.729,0-1.319-0.59-1.319-1.319v-7.797C61.325,240.42,61.916,239.83,62.644,239.83z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M369.041,99.063h36.247c0.728,0,1.319,0.591,1.319,1.319v7.797c0,0.729-0.591,1.319-1.319,1.319 h-36.247c-0.728,0-1.319-0.59-1.319-1.319v-7.797C367.722,99.654,368.313,99.063,369.041,99.063z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M328.257,99.063h36.247c0.728,0,1.319,0.591,1.319,1.319v7.797c0,0.729-0.591,1.319-1.319,1.319 h-36.247c-0.728,0-1.319-0.59-1.319-1.319v-7.797C326.938,99.654,327.528,99.063,328.257,99.063z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M346.421,86.132h36.247c0.728,0,1.319,0.591,1.319,1.319v7.797c0,0.728-0.591,1.319-1.319,1.319 h-36.247c-0.728,0-1.319-0.591-1.319-1.319v-7.797C345.102,86.723,345.693,86.132,346.421,86.132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M305.722,86.132h36.247c0.728,0,1.319,0.591,1.319,1.319v7.797c0,0.728-0.591,1.319-1.319,1.319 h-36.247c-0.728,0-1.319-0.591-1.319-1.319v-7.797C304.403,86.723,304.993,86.132,305.722,86.132z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M96.26,100.43h39.958c0.729,0,1.319,0.591,1.319,1.319v8.793c0,0.728-0.59,1.319-1.319,1.319 H96.26c-0.729,0-1.319-0.591-1.319-1.319v-8.793C94.941,101.021,95.532,100.43,96.26,100.43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M116.158,86.265h39.958c0.729,0,1.319,0.59,1.319,1.319v8.793c0,0.729-0.59,1.319-1.319,1.319 h-39.958c-0.728,0-1.319-0.59-1.319-1.319v-8.793C114.839,86.856,115.43,86.265,116.158,86.265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M71.575,86.265h39.958c0.729,0,1.319,0.59,1.319,1.319v8.793c0,0.729-0.59,1.319-1.319,1.319 H71.575c-0.729,0-1.319-0.59-1.319-1.319v-8.793C70.256,86.856,70.846,86.265,71.575,86.265z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M378.85,350.661h39.958c0.729,0,1.319,0.59,1.319,1.319v8.793c0,0.728-0.59,1.319-1.319,1.319 H378.85c-0.729,0-1.319-0.591-1.319-1.319v-8.793C377.531,351.251,378.121,350.661,378.85,350.661z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M398.747,336.496h39.958c0.729,0,1.319,0.591,1.319,1.319v8.793c0,0.728-0.59,1.319-1.319,1.319 h-39.958c-0.728,0-1.319-0.591-1.319-1.319v-8.793C397.428,337.086,398.019,336.496,398.747,336.496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M354.164,336.496h39.958c0.728,0,1.319,0.591,1.319,1.319v8.793c0,0.728-0.591,1.319-1.319,1.319 h-39.958c-0.728,0-1.319-0.591-1.319-1.319v-8.793C352.845,337.086,353.436,336.496,354.164,336.496z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M73.511,152.333c15.814-25.452,83.736-72.655,117.527-63.893 c29.648,7.688,14.709,82.407,42.432,93.8c29.204,12.002,82.912-56.229,115.013-50.72c51.056,8.762,108.674,117.077,82.892,153.414 c-28.64,40.365-160.694,77.687-216.848,66.048c-45.767-9.486-131.049-59.202-147.545-94.655 C55.632,231.932,59.028,175.642,73.511,152.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "#FFFFFF"
    },
    d: "M73.511,152.333c15.814-25.452,83.736-72.655,117.527-63.893 c29.648,7.688,14.709,82.407,42.432,93.8c29.204,12.002,82.912-56.229,115.013-50.72c51.056,8.762,108.674,117.077,82.892,153.414 c-28.64,40.365-160.694,77.687-216.848,66.048c-45.767-9.486-131.049-59.202-147.545-94.655 C55.632,231.932,59.028,175.642,73.511,152.333z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shadow"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "_x3C_Path_x3E__1_",
    style: {
      fill: "#F5F5F5"
    },
    cx: 245.178,
    cy: 412.391,
    rx: 193.889,
    ry: 11.323
  })), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE7A63"
    },
    d: "M132.005,306.004c0,0,7.368,27.299,12.022,27.235c4.654-0.065,11.74-14.246,16.636-17.95 c1.76-1.331,7.608-2.23,7.608-2.23l2.461-2.838c0.757-0.873,1.991-1.157,3.053-0.703l0,0c1.106,0.473,1.757,1.629,1.587,2.82 l-0.752,5.276c-0.169,1.186-1.111,2.113-2.3,2.263l-9.313,1.171c0,0-12.685,26.813-20.037,25.301 c-7.352-1.512-14.815-22.502-14.815-22.502L132.005,306.004z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M132.191,304.993l8.093,21.213c0,0-1.775,6.152-9.517,10.933c0,0-5.759-10.262-4.36-17.259 c1.063-5.317,3.529-11.995,4.651-14.895C131.259,304.467,131.993,304.473,132.191,304.993z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M130.624,306.125c-1.234,3.273-3.274,9.046-4.216,13.756c-1.399,6.997,4.36,17.259,4.36,17.259 c0.915-0.565,1.739-1.149,2.494-1.74c0.624,1.179,1.29,2.351,1.985,3.47c0.317-18.47-3.242-31.933-3.242-31.933L130.624,306.125z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M129.955,364.668c0,0-4.081,7.445,17.351,0.89c21.432-6.555,34.958-2.979,35.736,1.841 c0.777,4.82-12.561,38.229-61.244,43.059c0,0-32.467,5.308-48.271-12.656c-15.804-17.964-8.002-24.354-1.563-27.611 c6.438-3.258,15.923,2.651,16.234-3.724L129.955,364.668z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    d: "M175.66,379.838c0,0-20.139,20.057-44.745,20.835c-21.203,0.67-55.822-18.613-64.993-23.96 c-0.068,0.158-0.132,0.32-0.195,0.483l0.702,3.866c0,0-0.555,7.925,14.251,17.462H74.21 c16.033,17.078,47.588,11.934,47.588,11.934c31.093-3.085,47.753-17.822,55.541-29.329l0,0L175.66,379.838z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    d: "M88.042,375.271c0,0,17.791,1.749,35.891,9.329c0,0,28.012-13.819,34.892-13.265 s-27.754,22.944-27.754,22.944l-40.581-11.48L88.042,375.271z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M130.77,365.808c0,0,3.923-38.445,1.499-59.802c-0.137-1.212-0.978-2.219-2.155-2.537 c-5.417-1.462-22.192-4.804-48.092,0.742c-1.621,0.347-2.651,1.942-2.278,3.558c1.614,6.98,5.484,26.683,6.792,59.71 C86.536,367.477,116.165,372.484,130.77,365.808z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4
    },
    d: "M81.495,316.47c0.918,5.176,1.961,12.104,2.89,20.808c3.819-13.456,2.802-22.121,2.802-22.121 l-2.643-1.166L81.495,316.47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE7A63"
    },
    d: "M80.404,305.537c0,0-26.413,28.512-27.112,38.773c-0.566,8.304,9.711,21.14,13.653,25.735 c0.92,1.072,2.317,1.597,3.717,1.405l5.719-0.786l4.25,1.777c1.324,0.554,2.796-0.376,2.866-1.81l0.206-4.273 c0.047-0.983-0.604-1.864-1.558-2.106l-6.929-1.758l-4.898,1.241c0,0-8.563-15.444-4.748-21.05 c3.815-5.605,12.735-14.289,17.107-18.935C85.827,320.402,89.988,316.276,80.404,305.537z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M80.326,305.254c0,0-7.211,7.338-15.141,17.289c0,0,6.453,9.484,12.128,11.195 c0,0,10.728-10.495,9.873-18.58C86.451,308.198,80.326,305.254,80.326,305.254z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CE7A63"
    },
    points: "142.15,395.231 161.442,399.818 158.631,408.947 138.885,405.118  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M67.008,374.675c5.486-7.431,18.865-1.032,36.22,5.319c35.693,13.061,49.44,16.948,49.44,16.948 l-4.036,11.039c0,0-55.46-7.774-70.697-14.926C62.698,385.902,64.472,378.111,67.008,374.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M160.398,399.433l-4.336,9.593c-0.164,0.362-0.055,0.788,0.262,1.027l7.02,5.262 c0.619,0.471,1.504,0.351,1.975-0.268c0.061-0.08,0.113-0.165,0.155-0.256c1.503-3.485,2.704-6.646,4.656-10.948 c2.298-5.08,2.323-3.516,5.109-9.451c1.674-3.577-2.118-6.086-3.01-4.651c-4.037,6.587-6.473,6.359-10.191,7.923 C161.293,398.033,160.709,398.663,160.398,399.433z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    d: "M156.868,398.73l-4.465-1.061l0.266-0.727c0,0-2.254-0.637-7.302-2.261l-6.481,2.261l-11.35,4.334 l3.257,3.952c2.37,0.39,4.595,0.747,6.615,1.064L156.868,398.73z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "166.848,318.302 167.894,318.64 168.71,317.902 174.07,301.309 173.637,299.069  171.976,300.632 166.617,317.226  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2
    },
    points: "174.07,301.309 173.637,299.069 171.976,300.632  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE7A63"
    },
    d: "M102.794,301.975c2.11,1.586,6.312,6.385,12.018,5.634c3.664-0.482,2.513-4.066,2.946-5.894 c-3.937-1.611-4.694-4.643-4.314-8.374l-11.992-7.568C103.033,290.292,104.076,297.024,102.794,301.975z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M106.337,288.883l7.106,4.441c-0.089,1.049-0.089,2.104,0,3.153 c-2.434,0-5.792-1.563-7.106-4.042C105.502,290.926,105.751,289.158,106.337,288.883z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M112.843,278.344c-5.233-3.596-7.788-10.499-7.24-11.959c0.548-1.46,7.435-4.567,8.565-3.871 c5.652,3.32,3.298,12.194,3.298,12.194l1.858,2.79L112.843,278.344z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M112.843,278.344c-5.233-3.596-7.788-10.499-7.24-11.959 c0.548-1.46,7.435-4.567,8.565-3.871c5.652,3.32,3.298,12.194,3.298,12.194l1.858,2.79L112.843,278.344z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE7A63"
    },
    d: "M97.968,277.116c1.59,7.509,2.147,11.978,6.553,15.288c6.621,4.994,15.455,0.107,16.128-7.7 c0.608-7.082-2.105-18.134-9.967-20.039c-5.605-1.389-11.274,2.028-12.663,7.633C97.627,273.878,97.609,275.528,97.968,277.116z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M97.22,282.364c-4.854-4.088-8.448-10.337-7.693-11.686c2.011-3.573,8.479-5.871,12.368-3.653 c5.712,3.208,0.298,12.214,0.298,12.214s2.015,2.257,1.587,2.986C102.95,283.642,97.22,282.364,97.22,282.364z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M97.22,282.364c-4.854-4.088-8.448-10.337-7.693-11.686 c2.011-3.573,8.479-5.871,12.368-3.653c5.712,3.208,0.298,12.214,0.298,12.214s2.015,2.257,1.587,2.986 C102.95,283.642,97.22,282.364,97.22,282.364z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M110.145,277.537c0.094,0.62,0.492,1.073,0.896,1.01c0.405-0.063,0.653-0.608,0.56-1.228 c-0.094-0.62-0.492-1.064-0.897-1.001C110.299,276.381,110.051,276.926,110.145,277.537z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M117.11,276.5c0.094,0.611,0.492,1.064,0.897,1.001c0.405-0.063,0.653-0.608,0.559-1.219 c-0.094-0.611-0.492-1.073-0.896-1.01C117.266,275.335,117.017,275.88,117.11,276.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA4D3C"
    },
    d: "M114.56,277.119c1.018,1.773,2.276,3.397,3.739,4.826c-0.967,1.184-2.868,0.999-2.868,0.999 L114.56,277.119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M107.317,275.005c-0.062,0.009-0.125,0.005-0.186-0.012c-0.172-0.103-0.235-0.32-0.146-0.499 c0.546-1.044,1.559-1.763,2.724-1.934c0.203-0.016,0.38,0.134,0.397,0.337c0.016,0.203-0.135,0.38-0.337,0.397l0,0 c-0.921,0.145-1.716,0.722-2.139,1.553C107.56,274.95,107.442,275.009,107.317,275.005z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M119.401,273.283c-0.125,0.004-0.242-0.057-0.31-0.162c-0.501-0.777-1.341-1.271-2.264-1.33 c-0.202,0.004-0.369-0.156-0.373-0.358c-0.004-0.202,0.156-0.369,0.358-0.373c1.181,0.048,2.266,0.666,2.911,1.657 c0.113,0.16,0.075,0.382-0.086,0.495c-0.003,0.002-0.006,0.004-0.009,0.006C119.562,273.266,119.482,273.289,119.401,273.283z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M117.671,285.082c0,0-2.09-0.301-7.826,0.182c0.81,1.672,2.18,2.958,5.122,2.711 c1.48,0.017,2.694-1.169,2.712-2.649C117.68,285.245,117.678,285.164,117.671,285.082z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BA4D3C"
    },
    d: "M114.968,287.976c-1.422,0.12-2.475-0.122-3.276-0.589c0.49-0.313,1.05-0.5,1.635-0.524 c1.137-0.158,2.288,0.036,3.319,0.533C116.182,287.759,115.603,287.983,114.968,287.976z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M111.55,285.981c-0.548-0.007-1.056-0.286-1.357-0.744c1.588-0.128,2.89-0.196,3.929-0.226 c1.125-0.019,2.25-0.003,3.375,0.058c-0.081,0.44-0.401,0.798-0.829,0.929C114.965,286.133,113.253,286.127,111.55,285.981z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M115.327,283.561c0,0-1-0.991-3.707,0c-2.707,0.991-4.048,0.525-4.048,0.525 S109.147,286.418,115.327,283.561z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M115.91,283.562c0,0,0.662-0.991,2.453,0c1.791,0.991,2.679,0.525,2.679,0.525 S120,286.419,115.91,283.562z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M121.359,275.039c-0.29-1.8-1.652-2.598-3.837-2.246c-0.992,0.159-1.75,0.485-2.253,0.965 c-0.485,0.464-0.721,1.064-0.724,1.781l-0.738,0.102c-0.45-0.966-1.509-1.745-3.904-1.359c-1.085,0.175-1.916,0.508-2.471,0.99 c-0.04,0.035-0.064,0.077-0.102,0.114l-0.005-0.007c0,0-1.376,1.003-1.727,1.25c-1.362,0.958-5.158,4.005-5.32,4.134l0.438,0.545 c0.039-0.031,3.941-3.161,5.284-4.107c0.122-0.086,0.37-0.265,0.639-0.46c-0.042,0.291-0.055,0.596-0.001,0.93 c0.297,1.846,1.898,3.163,3.712,3.163c0.198,0,0.398-0.016,0.599-0.048c2.047-0.33,3.444-2.264,3.114-4.311 c-0.008-0.053-0.026-0.106-0.037-0.159l0.583-0.081c0.34,1.806,1.814,3.102,3.458,3.102c0.166,0,0.333-0.013,0.501-0.04 c0.911-0.147,1.704-0.675,2.23-1.488C121.319,277.008,121.518,276.024,121.359,275.039z M110.839,280.095 c-1.668,0.268-3.241-0.869-3.509-2.535c-0.121-0.751,0.063-1.326,0.561-1.759c0.455-0.395,1.168-0.674,2.122-0.828 c0.395-0.064,0.743-0.092,1.049-0.092c2.036,0,2.239,1.254,2.312,1.705C113.643,278.252,112.505,279.826,110.839,280.095z  M120.213,277.428c-0.418,0.645-1.041,1.063-1.754,1.178c-1.486,0.234-2.915-0.921-3.184-2.587 c-0.122-0.757,0.034-1.331,0.478-1.756c0.399-0.381,1.031-0.643,1.88-0.78c0.316-0.051,0.606-0.077,0.873-0.077 c1.264,0,1.974,0.576,2.162,1.743C120.8,275.964,120.638,276.772,120.213,277.428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CE7A63"
    },
    d: "M95.322,284.734c1.261,1.457,3.044,2.359,4.965,2.51c2.553,0.165,3.313-2.234,2.169-4.373 c-1.025-1.918-3.593-4.326-5.943-3.499C94.164,280.2,93.793,282.918,95.322,284.734z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M93.871,271.06c-3.265-0.501-7.21-3.635-2.148-8.832c2.458-2.523,5.784-3.286,8.555-4.364 c2.937-1.143,5.252-2.523,5.252-2.523l-2.298,3.265c0,0,8.013-1.574,9.587-5.481c0,0,2.099,3.557-0.758,6.997 c0,0,5.662-1.749,7.262,0.525c0,0-3.415,0.933-6.897,5.506C109.247,270.331,98.759,271.81,93.871,271.06z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CE7A63"
    },
    points: "123.181,396.941 109.124,405.96 113.384,412.322 128.156,405.96  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M110.555,403.94l5.505,8.974c0.208,0.338,0.153,0.775-0.132,1.052l-6.305,6.101 c-0.555,0.545-1.448,0.537-1.993-0.018c-0.07-0.071-0.132-0.15-0.186-0.234c-1.928-3.269-3.516-6.254-5.992-10.278 c-2.917-4.751-2.746-3.197-6.253-8.735c-2.11-3.339,1.339-6.303,2.403-4.991c4.831,6.029,7.219,5.497,11.104,6.582 C109.492,402.664,110.149,403.215,110.555,403.94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M123.025,408.947c64.059-20.49,67.946-35.639,59.55-43.258 c-8.168-7.412-19.145,1.618-28.459,8.691c-6.329,4.806-26.2,17.809-37.092,25.052L123.025,408.947z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M63.586,366.146c0,0,3.77-2.118,5.811-4.529l0.797,1.555c0,0-0.214,1.283-5.578,4.256 L63.586,366.146z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M69.805,363.89c0,1.052-0.853,1.905-1.905,1.905c-1.052,0-1.905-0.853-1.905-1.905 c0-1.052,0.853-1.905,1.905-1.905C68.952,361.985,69.805,362.838,69.805,363.89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    d: "M69.688,363.831c0,0.907-0.735,1.642-1.642,1.642c-0.907,0-1.642-0.735-1.642-1.642 c0-0.907,0.735-1.642,1.642-1.642C68.953,362.189,69.688,362.924,69.688,363.831z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Board"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M183.503,120.874c-0.227-2.769-2.54-4.901-5.319-4.901c-2.779,0-5.092,2.132-5.319,4.901 l-0.561,6.859h11.76L183.503,120.874z M178.184,124.451c-1.435,0-2.598-1.163-2.598-2.598c0-1.435,1.163-2.598,2.598-2.598 c1.435,0,2.598,1.163,2.598,2.598C180.782,123.287,179.619,124.451,178.184,124.451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M372.909,120.874c-0.227-2.769-2.54-4.901-5.319-4.901c-2.779,0-5.092,2.132-5.319,4.901 l-0.561,6.859h11.76L372.909,120.874z M367.591,124.451c-1.435,0-2.598-1.163-2.598-2.598c0-1.435,1.163-2.598,2.598-2.598 c1.435,0,2.598,1.163,2.598,2.598C370.189,123.287,369.026,124.451,367.591,124.451z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.314,
    y: 126.713,
    style: {
      fill: "#263238"
    },
    width: 263.191,
    height: 163.074
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.05,
    y: 133.449,
    style: {
      opacity: 0.9,
      fill: "#FFFFFF"
    },
    width: 249.719,
    height: 149.602
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 137.211,
    y: 285.312,
    style: {
      fill: "#263238"
    },
    width: 269.396,
    height: 7.816
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.211,
    y: 285.312,
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    width: 269.396,
    height: 7.816
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M212.558,253.798h-53.44v-93.059l0.487-0.487c14.465-14.465,38.001-14.465,52.466,0l0.487,0.487 V253.798z M162.443,250.473h46.791v-88.348c-13.042-12.533-33.749-12.534-46.791,0V250.473z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M212.558,253.798h-53.44v-93.059l0.487-0.487c14.465-14.465,38.001-14.465,52.466,0l0.487,0.487 V253.798z M162.443,250.473h46.791v-88.348c-13.042-12.533-33.749-12.534-46.791,0V250.473z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M210.896,252.136H160.78v-90.718l0.51-0.491c6.618-6.36,15.337-9.864,24.547-9.864c0,0,0,0,0,0 c9.211,0,17.928,3.503,24.547,9.864l0.511,0.491V252.136z M164.105,248.811h43.467v-85.967 c-5.931-5.459-13.62-8.456-21.733-8.456c-8.113,0-15.803,2.998-21.733,8.456V248.811z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M210.896,252.136H160.78v-90.718l0.51-0.491c6.618-6.36,15.337-9.864,24.547-9.864c0,0,0,0,0,0 c9.211,0,17.928,3.503,24.547,9.864l0.511,0.491V252.136z M164.105,248.811h43.467v-85.967 c-5.931-5.459-13.62-8.456-21.733-8.456c-8.113,0-15.803,2.998-21.733,8.456V248.811z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "208.201,177.567 208.201,175.074 187.085,175.074 187.085,153.957 184.591,153.957  184.591,175.074 163.475,175.074 163.475,177.567 184.591,177.567 184.591,200.345 163.475,200.345 163.475,202.839  184.591,202.839 184.591,225.617 163.475,225.617 163.475,228.111 184.591,228.111 184.591,249.227 187.085,249.227  187.085,228.111 208.201,228.111 208.201,225.617 187.085,225.617 187.085,202.839 208.201,202.839 208.201,200.345  187.085,200.345 187.085,177.567  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.9,
      fill: "#FFFFFF"
    },
    points: "208.201,177.567 208.201,175.074 187.085,175.074 187.085,153.957  184.591,153.957 184.591,175.074 163.475,175.074 163.475,177.567 184.591,177.567 184.591,200.345 163.475,200.345  163.475,202.839 184.591,202.839 184.591,225.617 163.475,225.617 163.475,228.111 184.591,228.111 184.591,249.227  187.085,249.227 187.085,228.111 208.201,228.111 208.201,225.617 187.085,225.617 187.085,202.839 208.201,202.839  208.201,200.345 187.085,200.345 187.085,177.567  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 234.643,
    y: 171.197,
    style: {
      fill: "#263238"
    },
    width: 1.584,
    height: 91.091
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.643,
    y: 171.197,
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    width: 1.584,
    height: 91.091
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M233.352,159.516c0.041-1.103-0.824-2.028-1.93-2.111c-1.107-0.084-2.102,0.7-2.227,1.797 c-0.869,7.662-1.739,15.324-2.608,22.986c-0.124,1.097,1.124,2.146,2.794,2.271c1.67,0.126,3.059-0.723,3.101-1.827 C232.771,174.928,233.062,167.222,233.352,159.516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M241.675,159.203c-0.124-1.097-1.12-1.881-2.227-1.798c-1.107,0.083-1.972,1.008-1.93,2.111 c0.29,7.706,0.58,15.411,0.871,23.117c0.042,1.103,1.432,1.953,3.101,1.827c1.67-0.126,2.919-1.174,2.794-2.272 C243.414,174.527,242.544,166.865,241.675,159.203z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M233.352,159.516c0.041-1.103-0.824-2.028-1.93-2.111c-1.107-0.084-2.102,0.7-2.227,1.797 c-0.869,7.662-1.739,15.324-2.608,22.986c-0.124,1.097,1.124,2.146,2.794,2.271c1.67,0.126,3.059-0.723,3.101-1.827 C232.771,174.928,233.062,167.222,233.352,159.516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M241.675,159.203c-0.124-1.097-1.12-1.881-2.227-1.798c-1.107,0.083-1.972,1.008-1.93,2.111 c0.29,7.706,0.58,15.411,0.871,23.117c0.042,1.103,1.432,1.953,3.101,1.827c1.67-0.126,2.919-1.174,2.794-2.272 C243.414,174.527,242.544,166.865,241.675,159.203z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M229.195,159.203c0.124-1.097-0.67-2.084-1.77-2.251c-1.1-0.167-2.154,0.539-2.361,1.624 c-1.445,7.575-2.89,15.149-4.335,22.724c-0.207,1.085,0.963,2.225,2.622,2.477c1.659,0.252,3.111-0.49,3.235-1.587 C227.456,174.527,228.325,166.865,229.195,159.203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M237.518,159.516c-0.042-1.103-0.974-1.96-2.083-1.96c-1.109,0-2.041,0.857-2.083,1.96 c-0.29,7.706-0.58,15.411-0.871,23.117c-0.042,1.103,1.28,2.055,2.954,2.055c1.673,0,2.995-0.951,2.954-2.055 C238.098,174.928,237.808,167.222,237.518,159.516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M245.806,158.575c-0.207-1.085-1.261-1.791-2.361-1.624c-1.1,0.167-1.894,1.154-1.77,2.251 c0.869,7.662,1.739,15.324,2.608,22.986c0.125,1.097,1.576,1.839,3.235,1.587c1.659-0.252,2.829-1.392,2.622-2.477 C248.695,173.725,247.25,166.15,245.806,158.575z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M229.195,159.203c0.124-1.097-0.67-2.084-1.77-2.251c-1.1-0.167-2.154,0.539-2.361,1.624 c-1.445,7.575-2.89,15.149-4.335,22.724c-0.207,1.085,0.963,2.225,2.622,2.477c1.659,0.252,3.111-0.49,3.235-1.587 C227.456,174.527,228.325,166.865,229.195,159.203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M237.518,159.516c-0.042-1.103-0.974-1.96-2.083-1.96c-1.109,0-2.041,0.857-2.083,1.96 c-0.29,7.706-0.58,15.411-0.871,23.117c-0.042,1.103,1.28,2.055,2.954,2.055c1.673,0,2.995-0.951,2.954-2.055 C238.098,174.928,237.808,167.222,237.518,159.516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M245.806,158.575c-0.207-1.085-1.261-1.791-2.361-1.624c-1.1,0.167-1.894,1.154-1.77,2.251 c0.869,7.662,1.739,15.324,2.608,22.986c0.125,1.097,1.576,1.839,3.235,1.587c1.659-0.252,2.829-1.392,2.622-2.477 C248.695,173.725,247.25,166.15,245.806,158.575z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M247.065,262.387c0.045-1.22-0.717-2.475-2.291-2.475c-6.226,0-12.452,0-18.678,0 c-1.571,0-2.334,1.255-2.291,2.475H247.065z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M247.065,262.387c0.045-1.22-0.717-2.475-2.291-2.475c-6.226,0-12.452,0-18.678,0 c-1.571,0-2.334,1.255-2.291,2.475H247.065z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M339.222,205.602h-24.847c-0.96,0-1.82,0.778-1.92,1.738l-3.959,37.669 c-0.101,0.96,0.595,1.738,1.555,1.738h24.848L339.222,205.602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M339.222,205.602h-24.847c-0.96,0-1.82,0.778-1.92,1.738l-3.959,37.669 c-0.101,0.96,0.595,1.738,1.555,1.738h24.848L339.222,205.602z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M282.141,243.314c0.126-1.198,3.477-33.082,3.603-34.28c0.199-1.895,1.897-3.432,3.792-3.432 h21.362c0.96,0,1.656,0.778,1.555,1.738l-3.959,37.669c-0.101,0.96-0.961,1.738-1.92,1.738h-21.362v-0.001 C283.317,246.746,281.942,245.21,282.141,243.314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M282.141,243.314c0.126-1.198,3.477-33.082,3.603-34.28 c0.199-1.895,1.897-3.432,3.792-3.432h21.362c0.96,0,1.656,0.778,1.555,1.738l-3.959,37.669c-0.101,0.96-0.961,1.738-1.92,1.738 h-21.362v-0.001C283.317,246.746,281.942,245.21,282.141,243.314z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M335.429,209.034c0.199-1.895,1.897-3.432,3.792-3.432c1.895,0,3.27,1.536,3.071,3.432 c-0.155,1.477-3.448,32.803-3.603,34.28c-0.199,1.895-1.897,3.432-3.793,3.432c-1.895,0-3.27-1.536-3.071-3.432 C331.952,242.117,335.303,210.232,335.429,209.034z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    d: "M335.429,209.034c0.199-1.895,1.897-3.432,3.792-3.432 c1.895,0,3.27,1.536,3.071,3.432c-0.155,1.477-3.448,32.803-3.603,34.28c-0.199,1.895-1.897,3.432-3.793,3.432 c-1.895,0-3.27-1.536-3.071-3.432C331.952,242.117,335.303,210.232,335.429,209.034z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M277.025,221.22c-3.082,0-19.792,0-22.874,0c-3.79,0-6.863,3.073-6.863,6.863 c0,3.791,3.073,6.863,6.863,6.863v25.48c0,1.066,0.864,1.929,1.929,1.929h3.005c1.066,0,18.803,0,19.869,0h3.005 c1.065,0,1.929-0.864,1.929-1.929v-32.344C283.889,224.293,280.816,221.22,277.025,221.22z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M277.025,221.22c-3.082,0-19.792,0-22.874,0c-3.79,0-6.863,3.073-6.863,6.863 c0,3.791,3.073,6.863,6.863,6.863v25.48c0,1.066,0.864,1.929,1.929,1.929h3.005c1.066,0,18.803,0,19.869,0h3.005 c1.065,0,1.929-0.864,1.929-1.929v-32.344C283.889,224.293,280.816,221.22,277.025,221.22z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M254.152,221.22c-3.79,0-6.863,3.073-6.863,6.863c0,3.791,3.073,6.863,6.863,6.863v25.48 c0,1.066,0.864,1.929,1.929,1.929h3.005c1.066,0,1.929-0.864,1.929-1.929v-32.344 C261.015,224.293,257.942,221.22,254.152,221.22z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M254.152,221.22c-3.79,0-6.863,3.073-6.863,6.863c0,3.791,3.073,6.863,6.863,6.863 v25.48c0,1.066,0.864,1.929,1.929,1.929h3.005c1.066,0,1.929-0.864,1.929-1.929v-32.344 C261.015,224.293,257.942,221.22,254.152,221.22z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M272.246,262.356h54.313c3.85,0,6.972-3.121,6.972-6.972v-5.443c0-3.85-3.121-6.972-6.972-6.972 h-54.313c-3.85,0-6.972,3.121-6.972,6.972v5.443C265.275,259.235,268.396,262.356,272.246,262.356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    d: "M272.246,262.356h54.313c3.85,0,6.972-3.121,6.972-6.972v-5.443 c0-3.85-3.121-6.972-6.972-6.972h-54.313c-3.85,0-6.972,3.121-6.972,6.972v5.443 C265.275,259.235,268.396,262.356,272.246,262.356z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M314.186,242.97L314.186,242.97c0-2.085-1.691-3.776-3.776-3.776h-19.034 c-2.085,0-3.776,1.69-3.776,3.776v0c0,2.085,1.69,3.776,3.776,3.776h19.034C312.495,246.746,314.186,245.055,314.186,242.97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M314.186,242.97L314.186,242.97c0-2.085-1.691-3.776-3.776-3.776h-19.034 c-2.085,0-3.776,1.69-3.776,3.776v0c0,2.085,1.69,3.776,3.776,3.776h19.034C312.495,246.746,314.186,245.055,314.186,242.97z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M287.6,242.97L287.6,242.97c0-2.085-1.691-3.776-3.776-3.776h-19.034 c-2.085,0-3.776,1.69-3.776,3.776v0c0,2.085,1.69,3.776,3.776,3.776h19.034C285.91,246.746,287.6,245.055,287.6,242.97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M287.6,242.97L287.6,242.97c0-2.085-1.691-3.776-3.776-3.776h-19.034 c-2.085,0-3.776,1.69-3.776,3.776v0c0,2.085,1.69,3.776,3.776,3.776h19.034C285.91,246.746,287.6,245.055,287.6,242.97z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M321.049,221.22c3.082,0,19.792,0,22.874,0c3.79,0,6.863,3.073,6.863,6.863 c0,3.791-3.073,6.863-6.863,6.863v25.48c0,1.066-0.864,1.929-1.929,1.929h-3.005c-1.065,0-18.803,0-19.869,0h-3.005 c-1.066,0-1.929-0.864-1.929-1.929v-32.344C314.186,224.293,317.258,221.22,321.049,221.22z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M321.049,221.22c3.082,0,19.792,0,22.874,0c3.79,0,6.863,3.073,6.863,6.863 c0,3.791-3.073,6.863-6.863,6.863v25.48c0,1.066-0.864,1.929-1.929,1.929h-3.005c-1.065,0-18.803,0-19.869,0h-3.005 c-1.066,0-1.929-0.864-1.929-1.929v-32.344C314.186,224.293,317.258,221.22,321.049,221.22z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M321.049,221.22c3.79,0,6.863,3.073,6.863,6.863c0,3.791-3.073,6.863-6.863,6.863v25.48 c0,1.066-0.864,1.929-1.929,1.929h-3.005c-1.066,0-1.929-0.864-1.929-1.929v-32.344 C314.186,224.293,317.258,221.22,321.049,221.22z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M321.049,221.22c3.79,0,6.863,3.073,6.863,6.863c0,3.791-3.073,6.863-6.863,6.863 v25.48c0,1.066-0.864,1.929-1.929,1.929h-3.005c-1.066,0-1.929-0.864-1.929-1.929v-32.344 C314.186,224.293,317.258,221.22,321.049,221.22z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M327.912,228.084h22.874c0,3.791-3.073,6.863-6.863,6.863h-22.874l0,0 C324.84,234.947,327.912,231.874,327.912,228.084z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M327.912,228.084h22.874c0,3.791-3.073,6.863-6.863,6.863h-22.874l0,0 C324.84,234.947,327.912,231.874,327.912,228.084z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 311.934,
    y: 155.002,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 647.0469 338.5377)",
    style: {
      fill: "#407BFF"
    },
    width: 23.179,
    height: 28.534
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.057,
    y: 161.04,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 595.2837 338.5376)",
    style: {
      fill: "#407BFF"
    },
    width: 23.17,
    height: 16.459
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.069,
    y: 162.148,
    style: {
      fill: "#407BFF"
    },
    width: 20.05,
    height: 14.242
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.934,
    y: 155.002,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 647.0469 338.5377)",
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    width: 23.179,
    height: 28.534
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.057,
    y: 161.04,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 595.2837 338.5376)",
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    width: 23.17,
    height: 16.459
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.069,
    y: 162.148,
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    width: 20.05,
    height: 14.242
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.245,
    y: 159.077,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 647.0469 338.5377)",
    style: {
      opacity: 0.8,
      fill: "#EBEBEB"
    },
    width: 16.558,
    height: 20.383
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.823,
    y: 162.749,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 595.2838 338.5377)",
    style: {
      opacity: 0.8,
      fill: "#FAFAFA"
    },
    width: 19.638,
    height: 13.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.713,
    y: 165.032,
    style: {
      opacity: 0.8,
      fill: "#FAFAFA"
    },
    width: 12.762,
    height: 8.474
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M360.723,242.798l-5.072-10.213c0,0,5.63,3.156,5.056-1.067c-0.574-4.223-2.463-0.645-3.464-2.105 c-1.001-1.459,2.084-1.836,0.7-4.066c-1.384-2.23-3.994,1.801-4.805-0.227c-0.811-2.028-1.813-2.985-4.028-2.511 c0,0-0.858,2.914,0.88,4.719c1.738,1.804-3.618,0.865-2.839,2.804c0.78,1.939,2.723,3.47,3.301,1.961 c0.577-1.509,1.884,1.075,0.678,1.937c-1.206,0.862,2.168,3.501,2.621,1.834c0.453-1.667,1.301-3.208,1.301-3.208l4.877,10.998 L360.723,242.798z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M363.461,242.015l5.347-11.912c0,0-6.3,3.862-5.832-0.995c0.468-4.857,2.79-0.848,3.87-2.563 c1.08-1.714-2.467-2.007-0.983-4.62c1.484-2.613,4.65,1.882,5.487-0.475c0.837-2.357,1.941-3.496,4.496-3.052 c0,0,1.111,3.296-0.796,5.438s4.178,0.828,3.373,3.081c-0.805,2.253-2.961,4.092-3.689,2.391 c-0.728-1.701-2.108,1.313-0.689,2.246c1.418,0.932-2.324,4.102-2.917,2.215c-0.593-1.887-1.632-3.612-1.632-3.612l-5.089,12.801 L363.461,242.015z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M363.461,242.015l5.347-11.912c0,0-6.3,3.862-5.832-0.995 c0.468-4.857,2.79-0.848,3.87-2.563c1.08-1.714-2.467-2.007-0.983-4.62c1.484-2.613,4.65,1.882,5.487-0.475 c0.837-2.357,1.941-3.496,4.496-3.052c0,0,1.111,3.296-0.796,5.438s4.178,0.828,3.373,3.081 c-0.805,2.253-2.961,4.092-3.689,2.391c-0.728-1.701-2.108,1.313-0.689,2.246c1.418,0.932-2.324,4.102-2.917,2.215 c-0.593-1.887-1.632-3.612-1.632-3.612l-5.089,12.801L363.461,242.015z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M360.954,243.131l0.822-18.193c0,0-6.189,8.242-8.074,1.702c-1.885-6.54,3.183-2.532,3.704-5.309 c0.521-2.778-4.23-1.338-3.646-5.488c0.584-4.151,6.997,0.055,6.873-3.432c-0.124-3.487,0.723-5.53,4.265-6.266 c0,0,3.133,3.705,1.758,7.462c-1.375,3.757,5.844-1.07,5.956,2.265s-1.741,6.827-3.558,4.994 c-1.817-1.833-2.06,2.786,0.258,3.267c2.318,0.482-0.909,6.514-2.647,4.371c-1.738-2.143-3.971-3.847-3.971-3.847l-0.031,19.214 L360.954,243.131z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M360.954,243.131l0.822-18.193c0,0-6.189,8.242-8.074,1.702 c-1.885-6.54,3.183-2.532,3.704-5.309c0.521-2.778-4.23-1.338-3.646-5.488c0.584-4.151,6.997,0.055,6.873-3.432 c-0.124-3.487,0.723-5.53,4.265-6.266c0,0,3.133,3.705,1.758,7.462c-1.375,3.757,5.844-1.07,5.956,2.265 s-1.741,6.827-3.558,4.994c-1.817-1.833-2.06,2.786,0.258,3.267c2.318,0.482-0.909,6.514-2.647,4.371 c-1.738-2.143-3.971-3.847-3.971-3.847l-0.031,19.214L360.954,243.131z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M356.462,262.357h10.71c0.749,0,1.368-0.583,1.414-1.33l1.135-18.472 c0.05-0.815-0.598-1.504-1.414-1.504h-12.98c-0.817,0-1.465,0.689-1.415,1.504l1.135,18.472 C355.094,261.774,355.713,262.357,356.462,262.357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M356.462,262.357h10.71c0.749,0,1.368-0.583,1.414-1.33l1.135-18.472 c0.05-0.815-0.598-1.504-1.414-1.504h-12.98c-0.817,0-1.465,0.689-1.415,1.504l1.135,18.472 C355.094,261.774,355.713,262.357,356.462,262.357z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M354.047,243.132h15.673c0.72,0,1.325-0.54,1.408-1.255v0c0.097-0.841-0.561-1.579-1.408-1.579 h-15.673c-0.847,0-1.505,0.738-1.408,1.579v0C352.722,242.592,353.327,243.132,354.047,243.132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M354.047,243.132h15.673c0.72,0,1.325-0.54,1.408-1.255v0 c0.097-0.841-0.561-1.579-1.408-1.579h-15.673c-0.847,0-1.505,0.738-1.408,1.579v0 C352.722,242.592,353.327,243.132,354.047,243.132z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Paint_Bucket"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 231.689,
    y: 351.803,
    style: {
      fill: "#407BFF"
    },
    width: 45.432,
    height: 58.711
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.689,
    y: 351.803,
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    width: 45.432,
    height: 58.711
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M259.385,382.237c0,2.75-2.229,4.98-4.98,4.98c-2.75,0-4.98-2.229-4.98-4.98 c0-2.75,4.98-13.654,4.98-13.654S259.385,379.487,259.385,382.237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    d: "M258.183,382.259c0.065,0.651-0.41,1.233-1.061,1.298 c-0.651,0.065-1.233-0.41-1.298-1.061c-0.065-0.651,0.606-5.819,0.606-5.819S258.117,381.608,258.183,382.259z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M279.964,354.371l-3.143,1.762c-1.562,0.876-3.457,0.919-5.057,0.115l0,0 c-1.523-0.765-3.318-0.765-4.84,0l-0.139,0.07c-1.523,0.765-3.318,0.765-4.84,0l-0.139-0.07c-1.523-0.765-3.318-0.765-4.84,0 l-0.139,0.07c-1.523,0.765-3.318,0.765-4.84,0l-0.139-0.07c-1.523-0.765-3.318-0.765-4.84,0l-0.139,0.07 c-1.523,0.765-3.318,0.765-4.84,0l-0.139-0.07c-1.523-0.765-3.318-0.765-4.84,0l-0.001,0c-1.6,0.804-3.495,0.761-5.057-0.115 l-3.143-1.762v-5.178h51.118V354.371z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M277.121,366.322v3.707c6.171,13.686,4.939,15,4.761,15.108 c-1.894,1.184-15.346-13.236-29.339-31.461l-1.228,0.944c0.065,0.086,6.653,8.654,13.66,16.803 c11.365,13.217,15.158,15.343,16.76,15.343c0.453,0,0.731-0.171,0.955-0.307C284.256,385.502,284.64,382.363,277.121,366.322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M277.121,366.322v3.707c6.171,13.686,4.939,15,4.761,15.108 c-1.894,1.184-15.346-13.236-29.339-31.461l-1.228,0.944c0.065,0.086,6.653,8.654,13.66,16.803 c11.365,13.217,15.158,15.343,16.76,15.343c0.453,0,0.731-0.171,0.955-0.307C284.256,385.502,284.64,382.363,277.121,366.322z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Paint_Roller"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M225.757,406.746h-37.556c-0.552,0-1-0.448-1-1l0,0c0-0.552,0.448-1,1-1h37.556 c0.797,0,1.444-0.646,1.444-1.444v-2.271c0-2.06-0.818-4.036-2.275-5.493l-14.247-14.247c-1.818-1.817-2.86-4.334-2.86-6.905h2 c0,2.045,0.829,4.046,2.274,5.491l14.247,14.248c1.832,1.832,2.861,4.316,2.861,6.907v2.27 C229.201,405.204,227.659,406.746,225.757,406.746z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M225.757,406.746h-37.556c-0.552,0-1-0.448-1-1l0,0c0-0.552,0.448-1,1-1h37.556 c0.797,0,1.444-0.646,1.444-1.444v-2.271c0-2.06-0.818-4.036-2.275-5.493l-14.247-14.247c-1.818-1.817-2.86-4.334-2.86-6.905h2 c0,2.045,0.829,4.046,2.274,5.491l14.247,14.248c1.832,1.832,2.861,4.316,2.861,6.907v2.27 C229.201,405.204,227.659,406.746,225.757,406.746z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M209.788,374.386h-1.94c-0.569,0-1.03-0.461-1.03-1.03v-20.192c0-0.569,0.461-1.03,1.03-1.03h1.94 c0.569,0,1.03,0.461,1.03,1.03v20.192C210.818,373.925,210.357,374.386,209.788,374.386z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M223.848,410.514h-32.145c-1.305,0-2.363-1.058-2.363-2.362v-4.811 c0-1.305,1.058-2.363,2.363-2.363h32.145c1.305,0,2.362,1.058,2.362,2.363v4.811C226.21,409.456,225.153,410.514,223.848,410.514 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M223.848,410.514h-32.145c-1.305,0-2.363-1.058-2.363-2.362v-4.811 c0-1.305,1.058-2.363,2.363-2.363h32.145c1.305,0,2.362,1.058,2.362,2.363v4.811C226.21,409.456,225.153,410.514,223.848,410.514 z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Rulers"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M146.501,236.642l47.685,47.63l-47.657,0.027L146.501,236.642z M174.867,276.283l-20.355-20.331 l0.012,20.342L174.867,276.283z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M146.501,236.642l47.685,47.63l-47.657,0.027L146.501,236.642z M174.867,276.283l-20.355-20.331 l0.012,20.342L174.867,276.283z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 339.302,
    y: 264.607,
    style: {
      fill: "#407BFF"
    },
    width: 56.833,
    height: 7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 339.308,
    y: 277.607,
    style: {
      fill: "#407BFF"
    },
    width: 56.833,
    height: 7
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 339.302,
    y: 264.607,
    style: {
      fill: "#FFFFFF"
    },
    width: 56.833,
    height: 7
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 339.308,
    y: 277.607,
    style: {
      fill: "#FFFFFF"
    },
    width: 56.833,
    height: 7
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M353.468,274.864c0.488-0.489,2.439-2.979,3.426-4.762c0.621,0.171,1.311,0.021,1.798-0.467 c0.721-0.722,0.721-1.892-0.001-2.613c-0.722-0.721-1.892-0.721-2.613,0.001c-0.487,0.488-0.637,1.178-0.465,1.798 c-1.781,0.988-4.27,2.941-4.759,3.43c-0.552,0.553-0.678,1.366-0.384,2.041c-0.676-0.293-1.489-0.166-2.041,0.386 c-0.488,0.489-2.44,2.979-3.426,4.762c-0.62-0.171-1.311-0.021-1.798,0.467c-0.721,0.722-0.721,1.892,0.001,2.613 c0.722,0.721,1.892,0.721,2.613-0.001c0.487-0.488,0.637-1.178,0.465-1.799c1.782-0.988,4.27-2.941,4.759-3.43 c0.552-0.553,0.678-1.366,0.384-2.042C352.102,275.542,352.915,275.416,353.468,274.864z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M353.468,274.864c0.488-0.489,2.439-2.979,3.426-4.762 c0.621,0.171,1.311,0.021,1.798-0.467c0.721-0.722,0.721-1.892-0.001-2.613c-0.722-0.721-1.892-0.721-2.613,0.001 c-0.487,0.488-0.637,1.178-0.465,1.798c-1.781,0.988-4.27,2.941-4.759,3.43c-0.552,0.553-0.678,1.366-0.384,2.041 c-0.676-0.293-1.489-0.166-2.041,0.386c-0.488,0.489-2.44,2.979-3.426,4.762c-0.62-0.171-1.311-0.021-1.798,0.467 c-0.721,0.722-0.721,1.892,0.001,2.613c0.722,0.721,1.892,0.721,2.613-0.001c0.487-0.488,0.637-1.178,0.465-1.799 c1.782-0.988,4.27-2.941,4.759-3.43c0.552-0.553,0.678-1.366,0.384-2.042C352.102,275.542,352.915,275.416,353.468,274.864z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M357.991,268.935c-0.335,0.335-0.878,0.335-1.213,0.001c-0.335-0.335-0.335-0.878,0-1.213 c0.335-0.335,0.878-0.335,1.213,0C358.326,268.057,358.326,268.6,357.991,268.935z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M345.071,281.867c-0.335,0.335-0.878,0.335-1.213,0.001c-0.335-0.335-0.335-0.878,0-1.213 c0.335-0.335,0.878-0.335,1.213,0C345.406,280.989,345.406,281.532,345.071,281.867z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M385.276,274.85c0.488-0.489,2.439-2.979,3.426-4.762c0.621,0.171,1.311,0.021,1.798-0.467 c0.721-0.722,0.721-1.892-0.001-2.613c-0.722-0.721-1.892-0.721-2.613,0.001c-0.487,0.488-0.637,1.178-0.465,1.798 c-1.782,0.988-4.27,2.941-4.759,3.43c-0.552,0.552-0.678,1.366-0.384,2.041c-0.676-0.293-1.489-0.166-2.041,0.386 c-0.488,0.489-2.44,2.979-3.426,4.762c-0.62-0.171-1.311-0.021-1.798,0.467c-0.721,0.722-0.721,1.892,0.001,2.613 c0.722,0.721,1.892,0.721,2.613-0.001c0.487-0.488,0.637-1.178,0.465-1.799c1.781-0.988,4.27-2.941,4.759-3.43 c0.552-0.553,0.678-1.366,0.384-2.042C383.911,275.529,384.724,275.402,385.276,274.85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M385.276,274.85c0.488-0.489,2.439-2.979,3.426-4.762 c0.621,0.171,1.311,0.021,1.798-0.467c0.721-0.722,0.721-1.892-0.001-2.613c-0.722-0.721-1.892-0.721-2.613,0.001 c-0.487,0.488-0.637,1.178-0.465,1.798c-1.782,0.988-4.27,2.941-4.759,3.43c-0.552,0.552-0.678,1.366-0.384,2.041 c-0.676-0.293-1.489-0.166-2.041,0.386c-0.488,0.489-2.44,2.979-3.426,4.762c-0.62-0.171-1.311-0.021-1.798,0.467 c-0.721,0.722-0.721,1.892,0.001,2.613c0.722,0.721,1.892,0.721,2.613-0.001c0.487-0.488,0.637-1.178,0.465-1.799 c1.781-0.988,4.27-2.941,4.759-3.43c0.552-0.553,0.678-1.366,0.384-2.042C383.911,275.529,384.724,275.402,385.276,274.85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M389.8,268.922c-0.335,0.335-0.878,0.335-1.213,0.001c-0.335-0.335-0.335-0.878-0.001-1.213 c0.335-0.335,0.878-0.335,1.213-0.001C390.135,268.043,390.135,268.586,389.8,268.922z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M376.88,281.853c-0.335,0.335-0.878,0.335-1.213,0c-0.335-0.335-0.335-0.878,0-1.213 c0.335-0.335,0.878-0.335,1.213,0C377.215,280.975,377.215,281.518,376.88,281.853z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Color_Palette"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M119.426,231.55l-40.101-47.343l12.718-10.772l40.101,47.343c2.975,3.512,2.539,8.77-0.973,11.745 v0C127.659,235.498,122.4,235.062,119.426,231.55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M119.426,231.55l-40.101-47.343l12.718-10.772l40.101,47.343 c2.975,3.512,2.539,8.77-0.973,11.745v0C127.659,235.498,122.4,235.062,119.426,231.55z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.526,
    y: 178.863,
    transform: "matrix(0.6463 0.7631 -0.7631 0.6463 172.8435 -3.8146)",
    style: {
      fill: "#407BFF"
    },
    width: 10.022,
    height: 11.377
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.526,
    y: 178.863,
    transform: "matrix(0.6463 0.7631 -0.7631 0.6463 172.8435 -3.8146)",
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    width: 10.022,
    height: 11.377
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.833,
    y: 188.67,
    transform: "matrix(0.6463 0.7631 -0.7631 0.6463 183.2634 -6.6855)",
    style: {
      fill: "#407BFF"
    },
    width: 10.023,
    height: 11.377
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.833,
    y: 188.67,
    transform: "matrix(0.6463 0.7631 -0.7631 0.6463 183.2634 -6.6855)",
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    width: 10.023,
    height: 11.377
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.14,
    y: 198.477,
    transform: "matrix(0.6463 0.7631 -0.7631 0.6463 193.6846 -9.5558)",
    style: {
      fill: "#407BFF"
    },
    width: 10.022,
    height: 11.377
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.447,
    y: 208.284,
    transform: "matrix(0.6463 0.7631 -0.7631 0.6463 204.1059 -12.426)",
    style: {
      fill: "#407BFF"
    },
    width: 10.022,
    height: 11.377
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.447,
    y: 208.284,
    transform: "matrix(0.6463 0.7631 -0.7631 0.6463 204.1059 -12.426)",
    style: {
      opacity: 0.2
    },
    width: 10.022,
    height: 11.377
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M132.143,220.778l-3.908-4.613l-12.718,10.772l3.908,4.613c2.975,3.512,8.233,3.947,11.745,0.973 C134.682,229.548,135.118,224.29,132.143,220.778z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M128.257,229.083c-1.13,0.957-2.822,0.817-3.779-0.313c-0.957-1.13-0.817-2.822,0.313-3.779 c1.13-0.957,2.822-0.817,3.779,0.313C129.527,226.434,129.387,228.126,128.257,229.083z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M121.185,232.265l-48.69-38.454l10.33-13.079l48.69,38.454c3.612,2.853,4.227,8.093,1.375,11.705 l0,0C130.038,234.502,124.797,235.118,121.185,232.265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M121.185,232.265l-48.69-38.454l10.33-13.079l48.69,38.454 c3.612,2.853,4.227,8.093,1.375,11.705l0,0C130.038,234.502,124.797,235.118,121.185,232.265z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.542,
    y: 186.237,
    transform: "matrix(0.7848 0.6198 -0.6198 0.7848 136.9381 -10.4767)",
    style: {
      fill: "#407BFF"
    },
    width: 10.023,
    height: 11.377
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.542,
    y: 186.237,
    transform: "matrix(0.7848 0.6198 -0.6198 0.7848 136.9381 -10.4767)",
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 10.023,
    height: 11.377
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.628,
    y: 194.203,
    transform: "matrix(0.7848 0.6198 -0.6198 0.7848 144.0462 -15.0135)",
    style: {
      fill: "#407BFF"
    },
    width: 10.023,
    height: 11.377
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.628,
    y: 194.203,
    transform: "matrix(0.7848 0.6198 -0.6198 0.7848 144.0462 -15.0135)",
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    width: 10.023,
    height: 11.377
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.715,
    y: 202.169,
    transform: "matrix(0.7848 0.6198 -0.6198 0.7848 151.1544 -19.5504)",
    style: {
      fill: "#407BFF"
    },
    width: 10.023,
    height: 11.377
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.801,
    y: 210.135,
    transform: "matrix(0.7848 0.6198 -0.6198 0.7848 158.2625 -24.0872)",
    style: {
      fill: "#407BFF"
    },
    width: 10.022,
    height: 11.377
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.801,
    y: 210.135,
    transform: "matrix(0.7848 0.6198 -0.6198 0.7848 158.2625 -24.0872)",
    style: {
      opacity: 0.2
    },
    width: 10.022,
    height: 11.377
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M131.515,219.186l-4.745-3.747l-10.33,13.079l4.745,3.747c3.612,2.852,8.852,2.237,11.705-1.375 S135.127,222.038,131.515,219.186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M129.352,228.096c-0.918,1.162-2.604,1.36-3.766,0.442c-1.162-0.918-1.36-2.604-0.442-3.766 s2.604-1.36,3.766-0.442C130.072,225.248,130.27,226.934,129.352,228.096z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M120.37,236.487l-54.817-29.061l7.807-14.725l54.817,29.061c4.066,2.156,5.615,7.2,3.459,11.266 l0,0C129.481,237.094,124.437,238.643,120.37,236.487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M120.37,236.487l-54.817-29.061l7.807-14.725l54.817,29.061 c4.066,2.156,5.615,7.2,3.459,11.266l0,0C129.481,237.094,124.437,238.643,120.37,236.487z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.08,
    y: 197.892,
    transform: "matrix(0.8835 0.4684 -0.4684 0.8835 104.2193 -11.9276)",
    style: {
      fill: "#407BFF"
    },
    width: 10.022,
    height: 11.377
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.08,
    y: 197.892,
    transform: "matrix(0.8835 0.4684 -0.4684 0.8835 104.2193 -11.9276)",
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 10.022,
    height: 11.377
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.436,
    y: 203.912,
    transform: "matrix(0.8835 0.4684 -0.4684 0.8835 108.3628 -16.5451)",
    style: {
      fill: "#407BFF"
    },
    width: 10.022,
    height: 11.377
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.436,
    y: 203.912,
    transform: "matrix(0.8835 0.4684 -0.4684 0.8835 108.3628 -16.5451)",
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    width: 10.022,
    height: 11.377
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.791,
    y: 209.932,
    transform: "matrix(0.8835 0.4684 -0.4684 0.8835 112.5053 -21.1627)",
    style: {
      fill: "#407BFF"
    },
    width: 10.022,
    height: 11.377
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.146,
    y: 215.952,
    transform: "matrix(0.8835 0.4684 -0.4684 0.8835 116.6479 -25.7804)",
    style: {
      fill: "#407BFF"
    },
    width: 10.022,
    height: 11.377
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.146,
    y: 215.952,
    transform: "matrix(0.8835 0.4684 -0.4684 0.8835 116.6479 -25.7804)",
    style: {
      opacity: 0.2
    },
    width: 10.022,
    height: 11.377
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M128.177,221.762l-5.342-2.832l-7.807,14.725l5.342,2.832c4.066,2.156,9.11,0.607,11.266-3.459 C133.792,228.962,132.243,223.918,128.177,221.762z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M127.653,230.916c-0.694,1.309-2.317,1.807-3.625,1.113c-1.308-0.694-1.807-2.317-1.113-3.625 c0.694-1.308,2.317-1.807,3.625-1.113C127.849,227.985,128.347,229.608,127.653,230.916z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Drawings"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 392.53,
    y: 174.985,
    style: {
      fill: "#407BFF"
    },
    width: 50.415,
    height: 67.42
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.53,
    y: 174.985,
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    width: 50.415,
    height: 67.42
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.435,
    y: 178.89,
    style: {
      opacity: 0.9,
      fill: "#FFFFFF"
    },
    width: 42.605,
    height: 59.61
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M431.735,209.285h-3.86V186.13h-12.731h-13.388v11.296v18.135v0.837v12.551h2.162v-3.318 c1.516,0.19,2.751,1.396,2.952,2.953l0.047,0.365h8.227v-2.237h16.59V209.285z M402.593,186.966h11.715v2.591 c-1.932,0.421-3.347,2.139-3.347,4.138v0.418h3.347v2.475h-11.715V186.966z M402.593,197.426h12.551v-4.149h-3.321 c0.19-1.517,1.397-2.752,2.956-2.953l0.365-0.047v-3.311h11.894v22.319h-12.731v1.904v3v1.371h-11.715V197.426z M415.145,211.19 h2.531c-0.171,1.379-1.181,2.512-2.531,2.862V211.19z M414.308,228.113h-6.671c-0.422-1.93-2.139-3.344-4.137-3.344h-0.418v3.344 h-0.488v-11.715h11.715v10.315V228.113z M430.898,225.876h-15.754v-9.478v-0.837v-0.642c1.959-0.403,3.393-2.124,3.393-4.147 v-0.418h-3.393v-0.231h12.731h3.023V225.876z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    d: "M431.735,209.285h-3.86V186.13h-12.731h-13.388v11.296v18.135v0.837v12.551h2.162 v-3.318c1.516,0.19,2.751,1.396,2.952,2.953l0.047,0.365h8.227v-2.237h16.59V209.285z M402.593,186.966h11.715v2.591 c-1.932,0.421-3.347,2.139-3.347,4.138v0.418h3.347v2.475h-11.715V186.966z M402.593,197.426h12.551v-4.149h-3.321 c0.19-1.517,1.397-2.752,2.956-2.953l0.365-0.047v-3.311h11.894v22.319h-12.731v1.904v3v1.371h-11.715V197.426z M415.145,211.19 h2.531c-0.171,1.379-1.181,2.512-2.531,2.862V211.19z M414.308,228.113h-6.671c-0.422-1.93-2.139-3.344-4.137-3.344h-0.418v3.344 h-0.488v-11.715h11.715v10.315V228.113z M430.898,225.876h-15.754v-9.478v-0.837v-0.642c1.959-0.403,3.393-2.124,3.393-4.147 v-0.418h-3.393v-0.231h12.731h3.023V225.876z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Papers"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M284.356,382.976c0,0-5.538,19.16-0.714,19.551c0,0,40.134-6.263,60.943-4.65 c20.809,1.613,46.43,6.636,46.43,6.636s1.72-4.868,1.468-10.273l-74.689-2.083l-25.518-5.235L284.356,382.976z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M284.356,382.976c0,0-5.538,19.16-0.714,19.551c0,0,40.134-6.263,60.943-4.65 c20.809,1.613,46.43,6.636,46.43,6.636s1.72-4.868,1.468-10.273l-74.689-2.083l-25.518-5.235L284.356,382.976z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M284.299,400.615c0,0-2.87-2.471,0.392-10.742l11.121,0.406l-0.332,9.093L284.299,400.615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M284.356,382.976c0,0,5.668,3.649-0.057,17.639c0,0,68.455-9.117,106.688,1.746 c0,0,2.735-7.215,0.892-15.457C391.879,386.904,305.197,386.75,284.356,382.976z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M284.356,382.976c0,0,5.668,3.649-0.057,17.639c0,0,68.455-9.117,106.688,1.746 c0,0,2.735-7.215,0.892-15.457C391.879,386.904,305.197,386.75,284.356,382.976z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M324.998,385.945c0.365,2.012,0.984,6.875-0.375,11.807c-0.144,0.523,0.286,1.027,0.827,0.982 c2.584-0.214,9.02-0.671,14.485-0.424c0.671,0.03,1.251-0.454,1.347-1.119c0.279-1.922,0.726-5.958,0.382-10.42 c-0.051-0.67-0.593-1.198-1.264-1.223l-14.592-0.533C325.303,384.997,324.908,385.447,324.998,385.945z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    d: "M324.998,385.945c0.365,2.012,0.984,6.875-0.375,11.807 c-0.144,0.523,0.286,1.027,0.827,0.982c2.584-0.214,9.02-0.671,14.485-0.424c0.671,0.03,1.251-0.454,1.347-1.119 c0.279-1.922,0.726-5.958,0.382-10.42c-0.051-0.67-0.593-1.198-1.264-1.223l-14.592-0.533 C325.303,384.997,324.908,385.447,324.998,385.945z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M280.833,410.146c0,0-5-20.291,0.067-20.5c0,0,41.759,8.229,63.614,7.408 c21.854-0.821,48.888-5.014,48.888-5.014s1.598,5.169,1.109,10.817l-78.285-0.931l-26.935,4.418L280.833,410.146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M280.833,410.146c0,0-5-20.291,0.067-20.5c0,0,41.759,8.229,63.614,7.408 c21.854-0.821,48.888-5.014,48.888-5.014s1.598,5.169,1.109,10.817l-78.285-0.931l-26.935,4.418L280.833,410.146z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M281.508,391.676c0,0-3.108,2.468-0.037,11.264l11.66,0.038l0.031-9.534L281.508,391.676z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M280.833,410.146c0,0,6.087-3.585,0.675-18.47c0,0,71.292,12.397,111.774,2.617 c0,0,2.563,7.668,0.29,16.221C393.572,410.514,302.81,407.064,280.833,410.146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M280.833,410.146c0,0,6.087-3.585,0.675-18.47c0,0,71.292,12.397,111.774,2.617 c0,0,2.563,7.668,0.29,16.221C393.572,410.514,302.81,407.064,280.833,410.146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M323.508,408.732c0.466-2.091,1.317-7.157,0.099-12.378c-0.129-0.554,0.342-1.063,0.907-0.994 c2.696,0.332,9.416,1.078,15.148,1.047c0.704-0.004,1.291,0.528,1.364,1.228c0.212,2.023,0.512,6.269-0.034,10.926 c-0.082,0.699-0.671,1.23-1.374,1.227l-15.3-0.05C323.789,409.736,323.393,409.249,323.508,408.732z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "#FFFFFF"
    },
    d: "M323.508,408.732c0.466-2.091,1.317-7.157,0.099-12.378 c-0.129-0.554,0.342-1.063,0.907-0.994c2.696,0.332,9.416,1.078,15.148,1.047c0.704-0.004,1.291,0.528,1.364,1.228 c0.212,2.023,0.512,6.269-0.034,10.926c-0.082,0.699-0.671,1.23-1.374,1.227l-15.3-0.05 C323.789,409.736,323.393,409.249,323.508,408.732z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M285.931,297.505c0,0,19.905-6.366,20.457-1.326c0,0-5.374,42.221-3.07,63.97 c2.304,21.748,8.322,48.435,8.322,48.435s-5.048,1.946-10.716,1.841l-4.388-78.168l-6.237-26.573L285.931,297.505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M285.931,297.505c0,0,19.905-6.366,20.457-1.326c0,0-5.374,42.221-3.07,63.97 c2.304,21.748,8.322,48.435,8.322,48.435s-5.048,1.946-10.716,1.841l-4.388-78.168l-6.237-26.573L285.931,297.505z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M304.405,296.924c0,0-2.673-2.933-11.24,0.728l0.754,11.636l9.514-0.616L304.405,296.924z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M285.931,297.505c0,0,3.99,5.829,18.474-0.581c0,0-7.527,71.97,4.98,111.694 c0,0-7.476,3.078-16.164,1.391C293.221,410.009,290.499,319.222,285.931,297.505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#FFFFFF"
    },
    d: "M285.931,297.505c0,0,3.99,5.829,18.474-0.581c0,0-7.527,71.97,4.98,111.694 c0,0-7.476,3.078-16.164,1.391C293.221,410.009,290.499,319.222,285.931,297.505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M290.241,339.986c2.118,0.323,7.23,0.828,12.356-0.742c0.544-0.166,1.084,0.269,1.053,0.837 c-0.148,2.712-0.436,9.467-0.016,15.184c0.051,0.702-0.439,1.324-1.132,1.444c-2.004,0.349-6.219,0.936-10.903,0.708 c-0.703-0.034-1.272-0.585-1.318-1.288l-0.989-15.268C289.258,340.334,289.717,339.906,290.241,339.986z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "#FFFFFF"
    },
    d: "M290.241,339.986c2.118,0.323,7.23,0.828,12.356-0.742 c0.544-0.166,1.084,0.269,1.053,0.837c-0.148,2.712-0.436,9.467-0.016,15.184c0.051,0.702-0.439,1.324-1.132,1.444 c-2.004,0.349-6.219,0.936-10.903,0.708c-0.703-0.034-1.272-0.585-1.318-1.288l-0.989-15.268 C289.258,340.334,289.717,339.906,290.241,339.986z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginSinistri);
export default __webpack_public_path__ + "static/media/login-sinistri.738aee3c54c2e7591d1a37e290645150.svg";
export { ForwardRef as ReactComponent };